import { globalEntitlements } from '../utils/globalEntitlements';

export const INITIAL_REPORT_ALLOWED_STATES = ['AK', 'CA'];

export const INITIAL_REPORT_CONFIG = {
  hero: {
    buyBox: [{
      bulletPoints: [
        { title: 'productPage.initialReportCalifornia.buyBox.bulletPoint1' },
        { title: 'productPage.initialReportCalifornia.buyBox.bulletPoint2' },
        { title: 'productPage.initialReportCalifornia.buyBox.bulletPoint3' }
      ],
      productName: 'productPage.initialReportCalifornia.buyBox.productName',
      couponBanner: {
        message: 'productPage.common.buyBox.couponBannerWfc'
      },
      interactService: {
        ctaType: 'internalCheckout',
        service: 'wfg_initial_report'
      }
    }],
    headerPicture: {
      src: '/s2/raster/chat-laughing-office.png',
      alt: 'productPage.initialReportCalifornia.heroPicture.altText'
    },
    headline: 'productPage.initialReportCalifornia.page.headline',
    partnerLogo: {},
    partnerReviewBlanks: [],
    pill: {
      text: 'productPage.initialReportCalifornia.page.headlinePill',
      bgcolor: 'background.red.light'
    },
    subheader: 'productPage.initialReportCalifornia.page.subheader'
  },
  benefit: {
    title: 'productPage.initialReportCalifornia.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/attachmoneyrounded.svg',
        title: 'productPage.initialReportCalifornia.valueProp.propTitle1',
        description: 'productPage.initialReportCalifornia.valueProp.shortCopy1'
      },
      {
        icon: '/s2/material-icons/workspacepremiumrounded.svg',
        title: 'productPage.initialReportCalifornia.valueProp.propTitle2',
        description: 'productPage.initialReportCalifornia.valueProp.shortCopy2'
      },
      {
        icon: '/s2/material-icons/healthandsafetyrounded.svg',
        title: 'productPage.initialReportCalifornia.valueProp.propTitle3',
        description: 'productPage.initialReportCalifornia.valueProp.shortCopy3'
      }
    ]
  },
  highlight: {
    icon: '/s2/material-icons/helpoutlinerounded.svg',
    title: 'productPage.initialReportCalifornia.topFeature.title',
    subheader: 'productPage.initialReportCalifornia.topFeature.subheader',
    image: '/s2/raster/phone-tablet-note-taking.png',
    alt: 'productPage.initialReportCalifornia.topFeature.altText'
  },
  faqs: {
    title: 'productPage.initialReportCalifornia.frequentlyAskedQuestions.title',
    items: [
      {
        question: 'productPage.initialReportCalifornia.frequentlyAskedQuestions.faq1',
        answer: 'productPage.initialReportCalifornia.frequentlyAskedQuestions.faqAnswer1'
      },
      {
        question: 'productPage.initialReportCalifornia.frequentlyAskedQuestions.faq2',
        answer: 'productPage.initialReportCalifornia.frequentlyAskedQuestions.faqAnswer2'
      },
      {
        question: 'productPage.initialReportCalifornia.frequentlyAskedQuestions.faq3',
        answer: 'productPage.initialReportCalifornia.frequentlyAskedQuestions.faqAnswer3'
      },
      {
        question: 'productPage.initialReportCalifornia.frequentlyAskedQuestions.faq4',
        answer: 'productPage.initialReportCalifornia.frequentlyAskedQuestions.faqAnswer4'
      }
    ]
  },
  assistance: {
    title: 'productPage.initialReportCalifornia.needAssistance.title',
    getInTouch: 'productPage.initialReportCalifornia.needAssistance.getInTouch',
    actions: 'productPage.initialReportCalifornia.needAssistance.actions'
  },
  getBuyButtonConfig: globalEntitlements({ ctaText: 'productPage.initialReportCalifornia.buyBox.buttonLabel' })
    .jurisdictionIn(INITIAL_REPORT_ALLOWED_STATES)
    .formedByZb()
    .currentProductNotPurchased()
    .build()
};
